import React from 'react';
import SvgIcon from '../../../../utils/SvgIcon';
import { useDashboardConfig } from '../../../hooks/useDashboardConfig';

const NextJobSummaryNoServices = () => {
  const { labels, noServicesIconUrl } = useDashboardConfig();

  return (
    <div className="next-job-summary">
      <div className="next-job-summary__body">
        <div className="next-job-summary__header">
          <div className="next-job-summary__icon-container">
            <SvgIcon viewBox="0 0 16 16" iconName="icon-portaltrash" className="next-job-summary__icon" />
          </div>
          <div className="next-job-summary__header-content">
            <div className="next-job-summary__title">{labels.noServicesHeading}</div>
          </div>
        </div>
        <div className="next-job-summary__content-card next-job-summary__content-card--noservices">
          {noServicesIconUrl ? (
            <img src={noServicesIconUrl} alt="notification" className="next-job-summary__status-card-icon" />
          ) : (
            <SvgIcon viewBox="0 0 16 16" iconName="info-circle" className="next-job-summary__status-card-icon" />
          )}
          <div className="next-job-summary__status-card-content">
            <h3 className="next-job-summary__status-card-title">{labels.noServicesMessageHeading}</h3>
            <p className="next-job-summary__status-card-description">{labels.noServicesMessageText}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NextJobSummaryNoServices;
